import React, { useEffect, useState } from "react";

import { IoCloseOutline } from "react-icons/io5";
import Customform from "../../../ui/custom-form";
import CustomInput from "../../../ui/custom-input";
import CustomButton from "../../../ui/custom-button";
import { PulseLoader } from "react-spinners";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import { useDispatch, useSelector } from "react-redux";
import {
  AddRamaStudentApi,
  GetRamaStudentDetailApi,
  UpdateEmployedata,
  UpdateRamaStudentdata,
} from "../../../api/api";

function AddRamaStudent() {
  const dispatch = useDispatch();
  const [cameraTypeInfo, setCameraTypeInfo] = useState([]);
  const [cameraGroupData, setCameraGroupData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [empId, setEmpid] = useState("");
  const [inputData, setInputData] = useState({
    employee_name: "",
    enroll_no: "",
  });
  console.log("inputData", inputData);
  const { data } = useSelector((state) => state?.PopupReducer?.modal || {});

  useEffect(() => {
    if (data) {
      fetchStudentData();
    }
  }, []);

  const fetchStudentData = async () => {
    try {
      const res = await GetRamaStudentDetailApi(data);
      const details = res?.data?.data;
      console.log("details", details);

      if (res?.data?.status === true && details) {
        // Set employee info
        setInputData({
          employee_name: details?.student_name || "",
          enroll_no: details?.enrollment_number || "", // Update enroll_no here
        });
        setEmpid(details?._id);
        // Set image preview
        if (details?.student_image) {
          setImagePreview(
            `https://visionemptrack.greymatterz.com/${details.student_image}`
          );
        }
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
      })
    );
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image_url") {
      if (files?.length > 0) {
        const file = files[0];
        const preview = URL.createObjectURL(file);
        setImagePreview(preview);
        setImageFile(file);
      }
    } else {
      setInputData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("student_name", inputData.employee_name);

      formData.append("enrollment_number", inputData.enroll_no);

      if (imageFile) {
        // New image uploaded
        formData.append("student_image", imageFile);
      } else if (imagePreview && imagePreview.includes("attendance_photos/")) {
        // Use the old image path from preview if not uploading a new one
        const imageResponse = await fetch(imagePreview);
        const blob = await imageResponse.blob();
        //console.log("blob", blob);
        const file = new File([blob], "existing-image.jpg", {
          type: blob.type,
        });
        //console.log("file", file);
        formData.append("student_image", file);
      }

      if (data) {
        formData.append("student_id", empId);
        const res = await UpdateRamaStudentdata(formData, data);
        if (res?.data?.status === true) {
          setLoading(false);
          handleClose();
        }
      } else {
        const res = await AddRamaStudentApi(formData);
        if (res?.data?.status === true) {
          setLoading(false);
          handleClose();
        }
      }
    } catch (err) {
      // }
      console.error("Failed to submit student data", err);
      setLoading(false);
    }
  };

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h4 className="m-0">{data ? "Edit Student" : "Add Student"}</h4>
        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <Customform onSubmit={handleSubmit}>
          <div className="col-12">
            <label className="form-label">Student Name</label>
            <CustomInput
              name="employee_name"
              placeholder="Enter Student Name"
              value={inputData.employee_name}
              onChange={handleChange}
            />
          </div>

          {/* <div className="col-12 mt-3">
            <label className="form-label">Camera Group Name</label>
            <select
              name="camera_group_id"
              className="form-select"
              value={inputData.camera_group_id}
              onChange={handleChange}
            >
              <option value="">Select Camera Group</option>
              {cameraGroupData?.map((ele) => (
                <option key={ele?._id} value={ele._id}>
                  {ele?.camera_grp_name || "Unnamed Group"}
                </option>
              ))}
            </select>
          </div> */}

          <div className="col-12 mt-3">
            <label className="form-label">Upload Student Image</label>
            <input
              type="file"
              accept="image/*"
              name="image_url"
              className="form-control"
              onChange={handleChange}
            />
          </div>
          <div className="col-12 mt-3">
            <label className="form-label">Enrollment Number</label>
            <input
              type="text"
              name="enroll_no"
              className="form-control"
              value={inputData.enroll_no}
              onChange={handleChange}
            />
          </div>

          {imagePreview && (
            <div className="col-12 mt-3">
              <label className="form-label">Image Preview</label>
              <img
                src={imagePreview}
                alt="Preview"
                className="img-thumbnail"
                style={{ width: "200px", height: "auto" }}
              />
            </div>
          )}

          <div className="bottomBtn d-flex justify-content-between mt-4">
            <button
              className="btn btn-outline-secondary px-4"
              type="button"
              onClick={handleClose}
            >
              Cancel
            </button>
            {loading ? (
              <CustomButton type="submit" className="btnSubmit px-4 py-2">
                <PulseLoader color="#fff" />
              </CustomButton>
            ) : (
              <button className="btnSubmit px-4 py-2" type="submit">
                Submit
              </button>
            )}
          </div>
        </Customform>
      </div>
    </div>
  );
}

export default AddRamaStudent;
